// src/pages/ServicePage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SERVICES } from '../data/mockData';
import { SERVICES_PAGE } from '../data/homeSeo';
import { servicesJsonLd } from '../data/pageSchema';
import Seo from '../components/Seo';
import './ServicePage.css';

const ServicePage = () => {
  const { user } = useAuth();
  const customerDest = user ? (user.type === 'provider' ? '/provider-dashboard' : '/customer-dashboard') : '/signup';

  const slugFromHash = window.location.hash.replace('#', '');
  const initialActive = SERVICES.find(s => s.slug === slugFromHash)?.id ?? null;
  const [active, setActive] = useState(initialActive);

  useEffect(() => {
    if (slugFromHash) {
      const el = document.getElementById(slugFromHash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [slugFromHash]);

  return (
    <div className="services-page">
      <Seo
        title={SERVICES_PAGE.title}
        description={SERVICES_PAGE.description}
        path={SERVICES_PAGE.path}
        jsonLd={servicesJsonLd()}
      />
      <div className="services-hero">
        <div className="hero-bg-lines" />
        <div className="services-hero-content">
          <div className="hero-eyebrow">What We Do</div>
          <h1>OUR <span>SERVICES</span></h1>
          <p>From a single bag of rubbish to a full house clearance — local carriers compete for your job.</p>
        </div>
      </div>

      <div className="page-wrapper">
        <div className="svc-page-grid">
          {SERVICES.map(svc => (
            <div
              key={svc.id}
              id={svc.slug}
              className={`svc-page-card ${active === svc.id ? 'expanded' : ''}`}
              onClick={() => setActive(active === svc.id ? null : svc.id)}
            >
              <div className="spc-header">
                <div className="spc-icon">{svc.icon}</div>
                <div className="spc-info">
                  <div className="spc-name">{svc.name}</div>
                  <div className="spc-desc">{svc.description}</div>
                </div>
                <div className="spc-right">
                  <div className="spc-credits">+{svc.credits} Credits</div>
                  <div className="spc-toggle">{active === svc.id ? '▲' : '▼'}</div>
                </div>
              </div>
              {active === svc.id && (
                <div className="spc-expanded">
                  <hr className="divider" />
                  <p className="spc-detail">
                    {svc.slug === 'scrap-collection' ? (
                      <>Scrap collection is free to the customer. A time is not promised.</>
                    ) : (
                      <>
                        Post {svc.name.toLowerCase()} and local carriers can send a price. Waste carriers are checked against the public register before they&apos;re approved.
                        Carriers earn <strong style={{color:'var(--teal)'}}>+{svc.credits} Eco Credits</strong> on completion.
                      </>
                    )}
                  </p>
                  <Link to={customerDest} className="btn btn-primary btn-sm">BOOK THIS SERVICE</Link>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="svc-cta-band">
          <h2>NOT SURE WHAT YOU NEED?</h2>
          <p>Post a job with a description and let carriers tell you what they can do.</p>
          <Link to={customerDest} className="btn btn-primary">POST A JOB FREE</Link>
        </div>
      </div>
    </div>
  );
};

export default ServicePage;
